import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import AOS from "aos";
import "aos/dist/aos.css";

export default function Contact() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({ duration: 1200 });
  }, []);

  return (
    <div className="contact-page">
      {/* Page Header */}
      <section className="page-header" data-aos="fade-up">
        <h1>{t("contact.title")}</h1>
      </section>

      {/* Contact Information Grid */}
      <section className="contact-info-section" data-aos="fade-up">
        <div className="contact-grid">
          {/* Contact Details */}
          <div className="contact-card" data-aos="fade-right">
            <h2>{t("contact.quickContact.title")}</h2>
            <div className="contact-item">
              <span className="contact-icon">📞</span>
              <div>
                <p>{t("contact.quickContact.phone1")}</p>
                <p>{t("contact.quickContact.phone2")}</p>
              </div>
            </div>
            <div className="contact-item">
              <span className="contact-icon">✉️</span>
              <div>
                <p>{t("contact.quickContact.email1")}</p>
              </div>
            </div>
          </div>

          {/* Work Hours */}
          <div className="contact-card" data-aos="fade-left">
            <h2>{t("contact.workHours.title")}</h2>
            <div className="work-hours-list">
              <div className="work-hour-item">
                <span>{t("contact.workHours.saturday")}</span>
                <span>{t("contact.workHours.time")}</span>
              </div>
              <div className="work-hour-item">
                <span>{t("contact.workHours.sunday")}</span>
                <span>{t("contact.workHours.time")}</span>
              </div>
              <div className="work-hour-item">
                <span>{t("contact.workHours.monday")}</span>
                <span>{t("contact.workHours.time")}</span>
              </div>
              <div className="work-hour-item">
                <span>{t("contact.workHours.tuesday")}</span>
                <span>{t("contact.workHours.time")}</span>
              </div>
              <div className="work-hour-item">
                <span>{t("contact.workHours.wednesday")}</span>
                <span>{t("contact.workHours.time")}</span>
              </div>
              <div className="work-hour-item">
                <span>{t("contact.workHours.thursday")}</span>
                <span>{t("contact.workHours.time")}</span>
              </div>
              <div className="work-hour-item closed">
                <span>{t("contact.workHours.friday")}</span>
                <span>{t("contact.workHours.closed")}</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Address Section */}
      <section className="address-section" data-aos="fade-up">
        <h2>{t("contact.address.title")}</h2>
        <p className="address-text">
          <span className="contact-icon">📍</span>
          {t("contact.address.full")}
        </p>
        <a
          href="https://www.google.com/maps?q=33.482944,44.381167"
          target="_blank"
          rel="noopener noreferrer"
          className="map-button"
        >
          🗺️ {t("contact.address.viewOnMap")}
        </a>
      </section>

    </div>
  );
}
